import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { DownloadWIthResume, FilterDownloadType } from "libs/dto/src/download";
import qs from "qs";

const download = async (page: number, filter?: FilterDownloadType | null) => {
  if (filter) {
    const response = await axios.get<{ page: number; data: DownloadWIthResume[] }>(`/downloads`, {
      params: {
        page: page,
        ...filter,
      },
      paramsSerializer: (params) => qs.stringify(params),
    });
    console.log(response.data);
    return response.data;
  }

  const response = await axios.get<{ page: number; data: DownloadWIthResume[] }>(`/downloads`, {
    params: {
      page: page,
    },
    paramsSerializer: (params) => qs.stringify(params),
  });
  console.log(response.data);
  return response.data;
};

export const useDownloads = (page: number, filter?: FilterDownloadType | null) => {
  const {
    data: downloads,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["downloads", page, filter],
    queryFn: () => download(page, filter),
  });

  return { downloads, loading, error };
};
